import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
import App from './App';
import { getQueryStringVariable } from './data/utils/getQueryStringVariable';
import { loadIdPvr } from './data/utils/loadIdPvr';
import { loadLanguage } from './data/utils/loadLanguage';
import { loadSessionToken } from './data/utils/loadSessionToken';
import { loadSystemCode } from './data/utils/loadSystemCode';
import InitData from './InitData';
import { appConfig, initAppConfig } from './appConfig';
import { getEnv } from './data/env';

initAppConfig();

export const warName = getEnv('REACT_APP_WAR_NAME') ? getEnv('REACT_APP_WAR_NAME') : 'XSportDatastore';
export const apiDomain = getEnv('REACT_APP_API_DOMAIN');
export const systemCode = loadSystemCode(apiDomain) || (appConfig['SYSTEM_CODE'] != null ? appConfig['SYSTEM_CODE'] : '');
export let  xs_sessionToken = null;
export const xs_instantSessionToken = getQueryStringVariable("tokenInstant");
export const xs_languageCode = loadLanguage();
export const xs_idPvr = loadIdPvr();
export const xs_isMobile = true;
export const xs_product_code = 1;
export var urls = window.xs_routes[systemCode] || window.xs_routes['DEFAULT'];

function setSessionToken() {
    xs_sessionToken = loadSessionToken();
}

setSessionToken();

window.xsp_reloadSessionToken = function() {
    setSessionToken();
    if (window.ucReloadUser) {
        window.ucReloadUser();
    } else {
        setTimeout(function () { window.xsp_reloadSessionToken()}, 100);
    }
}

if (typeof String.prototype.replaceAll === 'undefined') {
    console.log("replaceAll is not defined! I create it!");
    String.prototype.replaceAll = function(target, replacement) {
        return this.split(target).join(replacement);
    };
}

export function setUrls(u){
    urls = u;
}

// const appRoot = process.env.REACT_APP_ROOT;
// if (appRoot?.length > 0 && window.location.href.includes(appRoot)) {
//     urls.base = appRoot;
// }

window.xs_css = {}

window.whenJqueryLoaded(function () {  
    (function() {
        if (window.xs_css && window.xs_css[systemCode]) {
            const containerId = (window.appConfig && window.appConfig['CONTAINER_ID']) || null
            const href = window.xs_css[systemCode];
            const css = document.querySelectorAll("link[href='" + href + "']");
            if (!css.length) {
                let container;
                let isContainerHead = false;
                if (containerId) {
                    if (document.getElementById(containerId)) {
                        const nodes = document.getElementById(containerId).querySelectorAll('link');
                        container = nodes && nodes.length && nodes[nodes.length - 1];
                    }
                } else {
                    container = document.getElementsByTagName('head')[0];
                    isContainerHead = true;
                }
                
                if (container) {
                    var link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.href = href+'?xsv='+window.XSPORT_VERSION;
                    link.media = 'all';
                    if (isContainerHead) {
                        container.appendChild(link);
                    } else {
                        container.parentNode.insertBefore(link, container.nextSibling);
                    }
                }
            }
        }
    })();
});

(function () {
    if (window.self != window.top) {
        document.body.classList.add('xs_isIframe');
    }
}());

const root = ReactDOM.createRoot(document.getElementById('xs_mobile'));
root.render(
    <InitData>
        <App />
    </InitData>
);
